import { render } from "./CustomersView.vue?vue&type=template&id=43d24a3a"
import script from "./CustomersView.vue?vue&type=script&lang=js"
export * from "./CustomersView.vue?vue&type=script&lang=js"
script.render = render

export default script